import IcoMoon, { IconProps } from "react-icomoon";
import iconSet from "./selection.json";

const MudrexIcon = (props: IconProps) => {
  return <IcoMoon iconSet={iconSet} {...props} disableFill />;
};

MudrexIcon.defaultProps = {
  size: 16,
};

export default MudrexIcon;
